export const en = {
  yachtExp: 'Sailing Experience',
  nauticalMiles: 'nautical miles',
  days: 'Days',
  filterSet: 'filter settings',
  editColumns: 'Add/hide columns',
  viewMode: 'view mode',
  hide: 'hide',
  sendLog: 'Send logbook',
  yacht: 'Yacht',
  miles: 'Miles',
  marinaStart: 'Marina start',
  chooseMarinaStart: 'Choose marina start',
  marinaFinish: 'Marina finish',
  chooseMarinaFinish: 'Choose marina finish',
  route: 'Route',
  routeDetails: 'Enter route details',
  description: 'Description',
  tidalRegion: 'Tidal region',
  nonTidalRegion: 'Non-tidal region',
  allPeriod: 'For the entire period',
  enterManually: 'Enter manually',
  allTimeFrom: 'All the time from',
  allTimeUntil: 'All the time until',
  lastYear: 'Last Year',
  from: 'From',
  until: 'Until',
  choose: 'Choose',
  clearFilters: 'Clear all filters',
  confirmMail: 'We have sent you a letter to confirm your email.\n Check your inbox.',
  addMail: 'Add, please, your email to use all functionalities of logbook.',
  sendAgain: 'Your email is not yet confirmed.\n Should we send you one more letter with verification button?',
  confirmMailTost: 'Confirm your email to use all the functionality of the logbook',
  confirmSend: 'Yes, send it',
  sendAgainShort: 'Send again',
  confirmMailTitle: 'Confirm e-mail',
  cancel: 'Cancel',
  emptyLogbook: 'Hello!\n Your Online-Logbook has no sailing trips.\n To add first journey click on the button "Add trip".',
  addTrip: 'Add sailing trip',
  editTrip: 'Edit sailing trip',
  deleteTrip: 'Delete sailing trip',
  isDeleteTrip: 'Are you sure you want to delete this trip from your logbook?',
  infoTrip: 'Info about trip',
  dates: 'Dates',
  startDate: 'Start date',
  finishDate: 'Finish date',
  role: 'Role',
  isntChosen: 'Isn\'t chosen',
  yourRole: 'Your role in sailing trip',
  tidal: 'Tidal',
  nmPassed: 'Nm passed',
  nightHours: 'Night hours',
  nh: 'n/h',
  infoYacht: 'Info about yacht',
  model: 'Model',
  enterModel: 'Enter yacht model',
  yachtName: 'Yacht name',
  addNewModel: 'Add new yacht model',
  year: 'Year',
  chooseYear: 'Choose year',
  chooseYearList: 'Choose year from the list',
  ownerShip: 'Ownership',
  charter: 'Charter',
  private: 'Private',
  operator: 'Operator',
  yachtOwner: 'Yacht owner',
  notChosen: 'Not chosen',
  addToFavYacht: 'Add to favourite yacht',
  sailRegion: 'Sailing region',
  startBase: 'Start base',
  chooseStartBase: 'Choose start base',
  country: 'Country',
  countryStart: 'Country start',
  chooseCountryStart: 'Choose country start',
  countryFinish: 'Country finish',
  chooseCountryFinish: 'Choose country finish',
  choseCountryList: 'Choose country from the list',
  finishBase: 'Finish base',
  equalStartFinish: 'Finish base the same as the start base',
  chooseFinishBase: 'Choose finish base',
  chooseFinishCountry: 'Choose finish country',
  sailingIt: 'Sailing itinerary',
  enterRouteDetails: 'give bried details about itinerary',
  tripDetails: 'Trip details',
  tripDetailsHolder: 'Write everything what you suggest is important - Winds, weather, etc.',
  crewList: 'Crew-list',
  fileNotChosen: 'File hasn\'t chosen',
  chooseFile: 'Choose file',
  chooseFileFormat: 'Choose file of any format (pdf, png, jpeg, jpg), but not bigger then 10Mb.',
  save: 'Save',
  saveDraft: 'Save as draft',
  profile: 'Profile',
  licenses: 'Licenses',
  favYachts: 'Favorite yachts',
  yachts: 'Yachts',
  myTeam: 'My Team',
  sailResume: 'Sailing resume',
  resume: 'Resume',
  info: 'info',
  resetPassword: 'Reset password',
  signOut: 'Sign out',
  deleteAc: 'Delete account',
  daysInTheSea: 'days in the sea',
  email: 'Email',
  editProfile: 'Edit profile',
  name: 'Name',
  surname: 'Surname',
  phone: 'Phone',
  recoveryLetter: 'The recovery letter was sent to you mail.',
  sendLicense: 'Send license',
  sendLicenses: 'Send licenses',
  addLicense: 'Add license',
  issuedBy: 'Issued by',
  tintIyt: 'you can find IYT id number on the back side of license',
  licenseNumber: 'License number',
  licenseType: 'Type of license',
  chooseLicenseType: 'Choose type of license',
  sailSchool: 'Sailing school',
  instructor: 'Instructor',
  issueDate: 'Date of issue',
  chooseIssueDate: 'Choose date of issue',
  chooseStartDate: 'Choose start date',
  chooseFinishDate: 'Choose finish date',
  unlimited: 'Unlimited',
  validTill: 'Valid till',
  expiryDate: 'Date of expiry',
  chooseExpiryDate: 'Choose date of expire',
  frontSide: 'Frontside',
  backSide: 'Backside',
  choosePhoto: 'Choose photo',
  add: 'Add',
  attachSailResume: 'Attach Sailing Resume',
  recepients: 'Recipients',
  enterRecepientsMail: 'Enter recipient\'s mail',
  messageToRecepient: 'Message to recipient',
  messageToRecepientLicenseHolder: 'Hello! I send you my sailing license (and Sailing Resume) in attached file.',
  messageToRecepientLogbookHolder: 'Hello! I send you my logbook in attached file.',
  copyLink: 'Copy Link',
  addNewFavYacht: 'Add new yacht to Favourites',
  addYacht: 'Add yacht',
  modelName: 'Name of model',
  chooseYearProd: 'Choose year of yacht production',
  yachtType: 'Type of yacht',
  enterYachtType: 'Enter type of yacht',
  length: 'Length',
  width: 'Width',
  metres: 'm',
  fleetOperator: 'Fleet operator',
  operatorTint: 'Choose operator from list below or enter owner\'s name, if it private.',
  uploadPhoto: 'Upload photo',
  edit: 'Edit',
  editYachtInfo: 'Edit yacht info',
  change: 'Change',
  deleteYacht: 'Delete yacht',
  isDeleteYacht: 'Are you sure you want to delete the yacht',
  fromFav: 'from favorites yachts?',
  commonTrips: 'Common trips',
  sailedTogether: 'Sailed together',
  delFriend: 'Delete friend',
  isDelFriend: 'Do you really want to delete',
  fromTeam: ' from your team?',
  hasntCreatedResume: 'You still hasn\'t created Sailing resume',
  toCreateResume: 'To create your sailing resume click on button "Create resume".',
  beforeCreateResume: 'Before to create Resume, upload at least one Skipper license in License module and add at least 1 sailing trip to your Logbook.',
  createResume: 'Create resume',
  personalInfo: 'Personal info',
  skipper: 'Skipper',
  enterName: 'Enter your name on English',
  enterSurname: 'Enter your surname on English',
  birthDate: 'Date of birth',
  phoneNumber: 'Phone number',
  address: 'Address',
  addressPlaceholder: 'Town, Country',
  howLongSailing: 'How long have you been actively sailing?',
  since: 'Since',
  years: 'Years',
  doHaveLicenses: 'Do you have a sailing/boating license?',
  yes: 'Yes',
  no: 'No',
  doOwnBoat: 'Do you own a boat (or did you)?',
  haveBareboat: 'Have you bareboat charter before?',
  charterCompany: 'Charter company',
  sizeTypeBoat: 'Size and type of boat',
  nm: 'nm',
  sailingArea: 'Sailing area',
  showMoreCharters: 'Show more charters',
  totalExp: 'Total experience as',
  showLogbookLink: 'Show link to my logbook',
  knowAndExp: 'Identify your knowledge and experience:',
  dockingAlongside: 'Docking alongside',
  readingNaut: 'Reading nautical charts',
  pickMoor: 'Picking up a mooring',
  plotting: 'Plotting',
  coastNav: 'Coastal navigation',
  signleBow: 'Single bow anchor',
  crewMan: 'Crew-man',
  isAddCrew: 'Add information about Crew-man?',
  inviteMember: 'Invite member',
  toAddTheDataEnterMail: 'To add the data about your Crew-man enter his mail:',
  notFound: 'Not found',
  shareTrip: 'Share my trip',
  share: 'Share',
  shareTint: 'Your friend with whom you shared the post will receive a notification asking you to add this trip to their logbook.',
  send: 'Send',
  delete: 'Delete',
  invite: 'Invite',
  fine: 'Fine!',
  excellent: 'Excellent',
  logbookSended: 'A copy of the logbook has been sent',
  crewPersonalInfo: 'Crew-man personal info:',
  addAnotherTrip: 'Add another trip',
  iCertify: 'I certify that above information is true. I am aware and agree that if my competence in handling and navigating the yacht is not sufficient for bareboat charter, the Boatowner may terminate the charter or place a professional skipper aboard at my expense.',
  sendResume: 'Send skipper resume',
  enterRecMail: 'Enter recipient e-mail',
  recipients: 'Recipients',
  attachLicenses: 'Attach my licenses',
  addUpcomingCharter: 'Add upcoming charter details',
  bookingNumber: 'Booking number',
  clientsName: 'Client\'s name',
  departureDate: 'Departure date',
  departureBase: 'Departure base',
  arrivalDate: 'Arrival date',
  arrivalBase: 'Arrival base',
  hello: 'Hello!',
  yourLogEmpty: 'There are no entries in your Online-Logbook yet.',
  pressPlusToAdd: 'In order to add the first record, press the add trip button "+"',
  messageResumeHolder: 'Hello!\nI sent you my Sailing Resume.',
  preview: 'Preview',
  signUp: 'Sign Up',
  password: 'Password',
  confirmPassword: 'Password confirmation',
  agreePolitics: 'By signing up, you accept the Online Logbook',
  privacy: 'Privacy Policy and Terms of Service.',
  isHaveAc: 'Already have account?',
  signIn: 'Sign in',
  isForgotPass: 'Forgot your password?',
  dontHaveAc: 'Dont have and account?',
  getStarted: 'Get started.',
  darkTheme: 'Dark theme',
  logbook: 'Logbook',
  changePassword: 'Change password',
  organization: 'Organization',
  enterOrg: 'Enter organization',
  selectLicenseToSend: 'Select licenses to send',
  editLicense: 'Edit license',
  licenseSystem: 'License system',
  deleteLicense: 'Delete license',
  isDeleteLicense: 'Are you sure you want to remove the license',
  notRegisteredInfo: 'This user has not yet registered in the Online logbook.',
  myProfile: 'My profile',
  newNotifications: 'New notifications',
  sharedYachtTrip: 'shared a yachting trip with you',
  wantsToEdit: 'wants to make changes to the trip',
  isAccept: 'Do you accept them?',
  decline: 'Decline',
  accept: 'Accept',
  addIytLicenses: 'Adding IYT licenses',
  notFoundIYT: 'No licenses found for your IYT ID',
  selectAll: 'Select all',
  changingPassword: 'Change password',
  oldPassword: 'Old password',
  newPassword: 'New password',
  confirmPass: 'Confirm password',
  incorrectOldPassword: 'Incorrect old password entered',
  hideTrips: 'Hide trips',
  isHideTrips: 'Are you sure you want to hide all your hikes in the resume section?',
  confirmHide: 'Yes, hide',
  notHide: 'No, not hide',
  dateStartAndFinish: 'Start/finish date',
  milesTraveled: 'Miles traveled',
  chooseYacht: 'Choose yacht',
  savedInDraft: 'Your trip has been saved as a “Draft”. Fill in all the necessary information to make it active, and nautical miles count towards your skipper experience.',
  //errors
  requiredField: 'This field is required',
  emailOrPasswordIncorrect: 'Email or password entered incorrectly',
  emailExist: 'The email you entered already exists',
  passwordMismatch: 'Password mismatch',
  mailDoesNotExist: 'This mail does not exist',
  passwordChars: 'Password must be 8 characters',
  modelNotFound: 'Model not found. Please, select a model from the list or create a new one',
  operatorNotFound: 'Operator not found. Please, select an operator from the list',
  countryStartNotFound: 'Country not found. Please, select your start country from the list',
  countryFinishNotFound: 'Country not found. Please, select your finish country from the list',
  marinaStartNotFound: 'Marina not found. Please, select the start marina from the list',
  marinaFinishNotFound: 'Marina not found. Please, select the finish marina from the list',
  marinaNotFoundInCountry: 'The selected marina does not exist in this country: ',
  selectDates: 'Please, select dates',
  selectRole: 'Please, select a role from the list',
  selectStartCountry: 'Please, select your start country from the list',
  selectFinishCountry: 'Please, select your finish country from the list',
  selectModel: 'Please, enter a model name',
  selectYachtType: 'Please, select a yacht type from the list',
  shipyardNotFound: 'No such shipyard was found in the database, select the value “Custom shipyard”. if you think that we should add a new shipyard to the System Database - write to us at info@online-logbook.eu',
  enterYachtLength: 'Please, enter the length of the yacht',
  enterYachtWidth: 'Please, enter the width of the yacht',
  enterNameModel: 'Please, enter a model name',
  countryNotFound: 'Country not found. Please, select country from the list',
  licenseTypeNotFound: 'License type not found. Please, select a license type from the list',
  enter: 'Enter',
  onlyEnglish: 'on English',
  chooseYearYacht: 'To add a yacht to your favorites, select a year from the list',
  enterYachtName: 'To add a yacht to your favorites, enter the name of the yacht',
  invalidDate: 'Invalid date',
  // new
  marinaNotFound: 'Marina not found. Please, select the marina from the list',
  sailBoatLicenses: 'Sailing/boating licenses',
  boat: 'A boat',
  type: 'Type',
  port: 'Port',
  charterExp: 'Bareboat chartered experience',
  knowAndExpLabel: 'Knowledge and experience:',
  infoCrew: 'Information about Crew-man.',
  orFullManually: 'or full fill manually:',
  howLongCrewSail: 'How long have he/she been actively sailing?',
  isCrewLicenses: 'Does he/she have a sailing/boating licence?',
  isCrewBoat: 'Does he/she own a boat (or did)?',
  chartersBefore: 'Bareboat charters before.',
  isCrewCharteredBefore: 'Has he/she bareboat chartered before?',
  identifyCrewExp: 'Identify his/her knowledge and experience:',
  date: 'Date',
  hideTripInResume: 'Hide this trip in Resume',
  showTripInResume: 'Show this trip in Resume',
  chooseYachtType: 'Choose yacht type from the list',
  sendConfirmation: 'Send confirmation',
  notConfirmed: 'Email not confirmed',
  sentEmailForPassword: 'An email was sent to your mail to change your password',
  passwordChanged: 'Password changed successfully!',
  errorPassword: 'An error occurred while changing the password. Please try again later.',
  startDateBiggerEndDate: 'The start date can not be later than the finish date',
  showMore: 'Show more',
  requestToDelete: 'Request to delete my account and datas',
  areYouSure: 'Are you sure?',
  acceptDelete: 'Yes, delete',
  cancelDelete: 'No, cancel',
  jan: 'jan',
  feb: 'feb',
  mar: 'mar',
  apr: 'apr',
  may: 'may',
  june: 'june',
  july: 'july',
  aug: 'aug',
  sep: 'sep',
  oct: 'oct',
  nov: 'nov',
  dec: 'dec',

  passwordRecovery: 'Password recovery',
  enterEmail: "Enter email",
  editingTrip: 'Editing a trip',
  isShareChanges: 'Do you want to offer these changes to other trip members?',
  delivered: 'Added',
  cancelled: 'Cancelled',
  days_short: 'd',
  successRegister: 'An email has been sent to you with a link to confirm your registration.\nFollow the link to complete registration.',
  loadImagesForLicenses: 'Also upload photos of licenses to send them in a couple of clicks in the future',

  tripTeam: 'Trip members',
  sendInvitation: 'sent invitation',
  successAccept: 'Your email has been successfully confirmed!',
  inviteByLink: 'Invite by link',
  expiredLabelFirst: 'Your confirmation link has already expired.',
  expiredLabelSecond: 'To get new confirmation link on your email, please, click button “Send link”',
  page404: 'Alas, this page is lost somewhere in the ocean of the internet',
  toMain: 'Go to Main page'
}
